<template>
    <seccion-datos :titulo="configuracion" class="card card-success" @cambios="guardar()" :botonGuardar="permisomodif">
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('general.tipo') }}</label>
                    <select :disabled="!permisomodif" class="form-control" v-model="tipo_operario">
                        <option value="">----</option>
                        <option value="autonomo">{{ $t('general.autonomo') }}</option>
                        <option value="contratado">{{ $t('general.contratado') }}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-8">
                <div class="form-group">
                    <label v-if="sistema_facturacion_aplicacion=='verifactu' || sistema_facturacion_aplicacion=='no_factura'">Prefijo Liquidación</label>
                    <label v-else>Prefijo Auto-factura</label>
                    <input :disabled="!permisomodif || bloquearprefijo" v-model="prefijo_factura_operario" class="form-control nombre_completo dato"
                        id="nombre_completo" placeholder="">
                </div>
            </div>
        </div>
        <div class="row" v-if="sistema_facturacion_aplicacion=='verifactu' && tipo_operario=='autonomo'">
            <div class="col-md-6">
                <div class="form-group">
                    <label>Sistema de facturación</label>
                    <select :disabled="!permisomodif" class="form-control" v-model="sistema_facturacion">
                        <option value="">----</option>
                        <option value="liquidacion">Liquidación</option>
                        <option value="verifactu">Verifactu</option>
                    </select>
                </div>
            </div>
            <div class="col-md-6" v-if="sistema_facturacion=='verifactu'">
                <div class="form-group">
                    <label>Prefijo Auto-factura</label>
                    <input :disabled="!permisomodif || bloquearprefijoverifactu" v-model="prefijo_factura_verifactu_operario" class="form-control nombre_completo dato"
                        id="nombre_completo" placeholder="">
                </div>
            </div>
        </div>
        <div class="row" v-if="mostrarpresup==1">
            <div class="col-md-12">
                <div class="form-group">
                    <label>{{ $t('general.generapresupuestos') }}</label>
                    <select v-model="genera_presupuestos" :disabled="!permisomodif" class="form-control">
                        <option value="0">{{ $t('general.nogenera') }}</option>
                        <option value="2">{{ $t('general.conbaremooperario') }}</option>
                        <option value="3">{{ $t('general.conbaremocompania') }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{ $t('general.descincr') }}</label>
                    <select :disabled="!permisomodif" v-model="incr" class="form-control">
                        <option value="0">{{ $t('general.desc') }}</option>
                        <option value="1">Incr</option>
                    </select>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>&nbsp;</label>
                    <input :disabled="!permisomodif" v-model="descuento_negociado_operario"
                        class="form-control nombre_completo dato" id="nombre_completo" placeholder="">
                </div>
            </div>
        </div>
        <div class="row" v-if="tipo_operario=='contratado'">
            <div class="col-md-6">
                <div class="form-group">
                    <label>Importe nómina</label>
                    <div style="display: flex; gap: 1px;">
                        <input @input="cambiarPrecioHora()" v-model="nomina_operario"
                            class="form-control" id="nombre_completo" placeholder="">
                        <span style="font-size: x-large;">€</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>Precio/hora</label>
                    <input @input="cambiarNomina()" :disabled="!permisomodif" v-model="precio_hora_operario"
                        class="form-control nombre_completo dato" id="nombre_completo" placeholder="">
                </div>
            </div>
        </div>
        <div v-if="parametroAutofactura" class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>Método Auto-factura</label>
                    <select v-model="metodo_autofactura_operario" class="form-control">
                        <option title="Trabajos subsanados" value="">Trabajo</option>
                        <option title="Factura (a cliente) realizada" value="FACTURA">Factura</option>
                        <option title="Factura o albaran (a cliente) realizado" value="FACTURA_ALBARAN">Factura albarán
                        </option>
                        <option title="Factura (a cliente) cobrada" value="COBRO">Cobro</option>
                        <option title="Todas las facturas (a cliente) del expediente cobradas" value="COBRO_TODO">Cobro
                            todo</option>
                    </select>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{ $t('general.subcont') }}</label>
                    <input type="text" v-model="subcuenta_operario" :disabled="!permisomodif" class="form-control">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="custom-control custom-checkbox">
                    <input :disabled="!permisomodif" v-model="modulo_operario" v-bind:true-value="'SI'"
                        v-bind:false-value="''" type="checkbox" id="modulos" class="custom-control-input">
                    <label for="modulos" class="custom-control-label">{{ $t('general.modulos') }}</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="custom-control custom-checkbox">
                    <input :disabled="!permisomodif" v-model="permitir_incrementos" v-bind:true-value="1"
                        v-bind:false-value="0" type="checkbox" class="custom-control-input" id="increment">
                    <label for="increment" class="custom-control-label">{{ $t('general.permitirincrementos') }}</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="custom-control custom-checkbox">
                    <input :disabled="!permisomodif" v-model="envio_sms_automatico_operario" v-bind:true-value="1"
                        v-bind:false-value="0" type="checkbox" class="custom-control-input" id="enviosms"
                        placeholder="">
                    <label for="enviosms" class="custom-control-label">{{ $t('general.envioautomaticosms') }}</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="custom-control custom-checkbox">
                    <input :disabled="!permisomodif" v-model="envio_email_automatico_operario" v-bind:true-value="1"
                        v-bind:false-value="0" type="checkbox" class="custom-control-input" id="envioemail"
                        placeholder="">
                    <label for="envioemail" class="custom-control-label">{{ $t('general.envioautomaticoemail')
                        }}</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="custom-control custom-checkbox">
                    <input :disabled="!permisomodif" v-model="opcion_finaliza_visita" v-bind:true-value="1"
                        v-bind:false-value="0" type="checkbox" class="custom-control-input" id="visitaintranet">
                    <label for="visitaintranet" class="custom-control-label">{{ $t('general.finalizarvisitaintranet')
                        }}</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="custom-control custom-checkbox">
                    <input :disabled="!permisomodif" v-model="supervisor" v-bind:true-value="1" v-bind:false-value="0"
                        type="checkbox" class="custom-control-input" id="supervisor">
                    <label for="supervisor" class="custom-control-label">{{ $t('general.supervisoroperarios') }}</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="preferente" :disabled="!permisomodif"
                        v-model="preferente_operario" v-bind:true-value="1" v-bind:false-value="0">
                    <label for="preferente" class="custom-control-label">{{ $t('general.preferente') }}</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" id="datosperito" class="custom-control-input" :disabled="!permisomodif"
                        v-model="mostrar_datos_perito" v-bind:true-value="1" v-bind:false-value="0">
                    <label for="datosperito" class="custom-control-label">{{ $t('general.mostrardatosperito') }}</label>
                </div>
            </div>
            <div class="col-md-6" v-if="operario_asignaciones">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="1visita" :disabled="!permisomodif"
                        v-bind:true-value="1" v-model="puede_citar" v-bind:false-value="0">
                    <label for="1visita" class="custom-control-label">{{ $t('general.puededarprimeravisita') }}</label>
                </div>
            </div>
            <div class="col-md-6" v-if="operario_siguientes_citas">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" v-model="siguientes_citas" id="2visita" :disabled="!permisomodif"
                        class="custom-control-input" v-bind:true-value="1" v-bind:false-value="0">
                    <label for="2visita" class="custom-control-label">{{ $t('general.puededarsegundavisita') }}</label>
                </div>
            </div>
            <div class="col-md-12">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" id="autopresu" :disabled="!permisomodif" class="custom-control-input"
                        v-model="autoaprobado_operario" v-bind:true-value="1" v-bind:false-value="0">
                    <label for="autopresu" class="custom-control-label">{{ $t('general.autoaprovadospresupuestos')
                        }}</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="custom-control custom-checkbox">
                    <input :disabled="!permisomodif" v-model="establecer_iva" v-bind:true-value="1"
                        v-bind:false-value="0" type="checkbox" class="custom-control-input" id="iva">
                    <label for="iva" class="custom-control-label">Establecer IVA<span v-if="establecer_iva == 1"> (%)</span></label>
                </div>
            </div>
            <div v-if="establecer_iva == 1" class="col-md-6 pt-3 pb-3">
                <input :disabled="!permisomodif" v-model="iva_operario" class="form-control dato" id="iva_operario"
                    placeholder="">
            </div>
        </div>
        <div class="row" v-if="mostrar_citas_confirmar==1">
            <div class="col-md-12">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" v-model="siempre_muestra_citas_confirmar" class="custom-control-input" id="mostrar_citas_confirmar" v-bind:true-value="1" v-bind:false-value="0">
                    <label for="mostrar_citas_confirmar" class="custom-control-label">{{ $t('general.siempre_muestra_citas_por_confirmar') }}</label>
                </div>
            </div>
        </div>
        <!-- Se omite el acceso de email/clave ya que no se usa ni están contemplado en el acceso al webmail -->
    </seccion-datos>
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
export default {
    props: ['id', 'operario', 'permisomodif'],
    data() {
        return {
            sistema_facturacion_aplicacion:false,
            sistema_facturacion:'',
            precio_hora_operario: '',
            nomina_operario: '',
            parametroAutofactura:false,
            metodo_autofactura_operario:'',
            tipo_operario: '',
            id_reparador: '',
            incr: '',
            descuento_negociado_operario: '',
            modulo_operario: '',
            permitir_incrementos: '',
            opcion_finaliza_visita: '',
            supervisor: '',
            envio_email_automatico_operario: '',
            envio_sms_automatico_operario: '',
            configuracion: 'Configuración',
            establecer_iva: '',
            iva_operario: '',
            preferente_operario: '',
            mostrar_datos_perito: '',
            puede_citar: '',
            siguientes_citas: '',
            autoaprobado_operario: '',
            subcuenta_operario: '',
            genera_presupuestos: '',
            mostrarpresup: false,
            prefijo_factura_operario: '',
            prefijo_factura_verifactu_operario: '',
            bloquearprefijo: false,
            siempre_muestra_citas_confirmar:false,
            mostrar_citas_confirmar:false,
            operario_asignaciones:false,
            operario_siguientes_citas:false,
            bloquearprefijoverifactu:false
        }
    },
    methods: {
        cambiarPrecioHora(){             
            var aux=this.nomina_operario/160;
            this.precio_hora_operario = parseFloat(aux.toFixed(2));       
        },
        cambiarNomina(){
            var aux=this.precio_hora_operario*160;
            this.nomina_operario = parseFloat(aux.toFixed(2));
        },
        cargarDatosOperario() {
         this.$store.dispatch('cambiarCargando', true);
            this.sistema_facturacion = this.operario.sistema_facturacion;
            this.nomina_operario = this.operario.nomina_operario;
            this.precio_hora_operario = this.operario.precio_hora_operario;
            this.tipo_operario = this.operario.tipo_operario;
            this.id_reparador = this.operario.id_reparador;  
            this.iva_operario = this.operario.iva_operario;          
            this.incr = this.operario.incr;
            this.puede_citar = this.operario.puede_citar;
            this.siguientes_citas = this.operario.siguientes_citas;
            this.autoaprobado_operario = this.operario.autoaprobado_operario;
            this.descuento_negociado_operario = this.operario.descuento_negociado_operario;
            this.modulo_operario = this.operario.modulo_operario;
            this.permitir_incrementos = this.operario.permitir_incrementos;
            this.opcion_finaliza_visita = this.operario.opcion_finaliza_visita;
            this.supervisor = this.operario.supervisor;
            this.subcuenta_operario = this.operario.subcuenta_operario;
            this.envio_email_automatico_operario = this.operario.envio_email_automatico_operario;
            this.envio_sms_automatico_operario = this.operario.envio_sms_automatico_operario;
            this.metodo_autofactura_operario = this.operario.metodo_autofactura;
            this.establecer_iva = this.operario.establecer_iva;
            this.preferente_operario = this.operario.preferente_operario;
            this.mostrar_datos_perito = this.operario.mostrar_datos_perito;
            this.genera_presupuestos = this.operario.genera_presupuestos;
            this.prefijo_factura_operario = this.operario.prefijo_factura_operario;
            this.prefijo_factura_verifactu_operario = this.operario.prefijo_factura_verifactu_operario;
            this.configuracion = this.$t("general.configuracion");
            this.$store.dispatch('cambiarCargando', false);
            this.siempre_muestra_citas_confirmar = this.operario.siempre_muestra_citas_confirmar
        },
        async guardar() {
            /* put  modulos/pwgsapi/index.php/operarios/:id */
            try {
                const api = new PwgsApi;
                const subidadatos = { sistema_facturacion:this.sistema_facturacion,genera_presupuestos: this.genera_presupuestos, subcuenta_operario: this.subcuenta_operario,
                        autoaprobado_operario: this.autoaprobado_operario, siguientes_citas:this.siguientes_citas,puede_citar:this.puede_citar,
                        mostrar_datos_perito: this.mostrar_datos_perito, preferente_operario: this.preferente_operario, iva_operario: this.iva_operario,
                        establecer_iva: this.establecer_iva, metodo_autofactura:this.metodo_autofactura_operario, tipo_operario: this.tipo_operario,
                        id_reparador: this.id_reparador, incr: this.incr, descuento_negociado_operario: this.descuento_negociado_operario, 
                        modulo_operario: this.modulo_operario, permitir_incrementos: this.permitir_incrementos, opcion_finaliza_visita: this.opcion_finaliza_visita,
                        supervisor: this.supervisor, envio_email_automatico_operario: this.envio_email_automatico_operario, 
                        envio_sms_automatico_operario: this.envio_sms_automatico_operario,prefijo_factura_operario:this.prefijo_factura_operario,prefijo_factura_verifactu_operario:this.prefijo_factura_verifactu_operario,
                        precio_hora_operario: this.precio_hora_operario, nomina_operario: this.nomina_operario, siempre_muestra_citas_confirmar:this.siempre_muestra_citas_confirmar };
                this.$store.dispatch('cambiarGuardando', true);
                await api.put('operarios/' + this.operario.id, subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }finally{
                this.$store.dispatch('cambiarGuardando', false);
            }
        },
        async parametroAuto() {
            const api = new PwgsApi();
            var pa = await api.get('parametros-pwgs/metodo_autofactura_por_operario');
            if(pa.metodo_autofactura_por_operario=='1'){
                this.parametroAutofactura = true;
            }
        },
        async parametroPresup() {
            const api = new PwgsApi();
            let aux = await api.get('parametros-pwgs/operario_presupuestos');
            this.mostrarpresup = aux.operario_presupuestos;
        },
        async comprobarVerifactu(){
            const api = new PwgsApi();
            let aux = await api.get('parametros-pwgs/sistema_facturacion');
            this.sistema_facturacion_aplicacion = aux.sistema_facturacion;

            const resp2 = await api.get('operarios/'+this.id+'/tiene-factura-verifactu');
            if(resp2==="1"){
                this.bloquearprefijoverifactu = true;
                this.bloquearprefijo = false;
            }
        },
        async comprobarautofactura() { 
            const api = new PwgsApi();
            var body = {nombre: this.$props.operario.nombre,verifactu:1}
            const resp = await api.post('facturacion-operarios/autofacturas', body);
            console.log("resp", resp);
            if(resp.datos.length>0){
                this.bloquearprefijo = true;
                if(this.bloquearprefijoverifactu){
                    this.bloquearprefijo = false;
                }
            }
        },
        async parametroCitasConfirmar() {
            const api = new PwgsApi();
            let aux = await api.get('parametros-pwgs/siempre_muestra_citas_confirmar');
            this.mostrar_citas_confirmar = aux.siempre_muestra_citas_confirmar;
        },
        async comprobarParametros(){
            const api = new PwgsApi();
            var aux = await api.get('parametros-pwgs/operario_asignaciones');
            if (aux.operario_asignaciones == 1) {
                this.operario_asignaciones = true;
            }
            aux = await api.get('parametros-pwgs/operario_siguientes_citas');
            if (aux.operario_siguientes_citas == 1) {
                this.operario_siguientes_citas = true;
            }
        },
    },
    mounted() {
        this.comprobarVerifactu();
        this.cargarDatosOperario();
        this.parametroAuto();
        this.parametroPresup();
        this.comprobarautofactura();
        this.parametroCitasConfirmar();
        this.comprobarParametros();
    },
    watch: {
        operario() {
            this.cargarDatosOperario();
        },
    },
}
</script>